"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullish = exports.delay = exports.stringifyJson = void 0;
function stringifyJson(obj, replacer, space = 2) {
    const refPaths = new Map();
    return JSON.stringify(obj, function (k, v) {
        let value = replacer ? replacer(v, k) : v;
        if (typeof value === 'object' && value !== null) {
            const refPath = refPaths.get(value);
            if (refPath) {
                return `[Circular: ${refPath}]`;
            }
            if (value instanceof Error) {
                const { message, stack } = value, props = __rest(value, ["message", "stack"]);
                value = Object.assign(Object.assign({ message: [value.constructor.name, message]
                        .filter(Boolean)
                        .join(': ') }, props), { stack: stack === null || stack === void 0 ? void 0 : stack.replace(/^.+?( {4}at )/su, '$1').split('\n').map((item) => item.trim()) });
            }
            const parentPath = refPaths.get(this);
            refPaths.set(value, parentPath ? `${parentPath}.${k}` : k);
        }
        return value;
    }, space);
}
exports.stringifyJson = stringifyJson;
function delay(fn, ms = 200) {
    return __awaiter(this, void 0, void 0, function* () {
        yield new Promise((resolve) => {
            setTimeout(() => resolve(null), ms);
        });
        return fn && fn();
    });
}
exports.delay = delay;
function isNullish(v) {
    return v === null || v === undefined;
}
exports.isNullish = isNullish;
